import {
    NEXT_STEP, SET_NAV_TAB, SET_SIDEBAR_MOBILE_OPEN, CLEAR_GLOBAL_ERROR_MSG,
    SET_COMPANY_LOGO_FILE, DELETE_COMPANY_LOGO_FILE, CLEAR_COMPANY_ACTION_STATUS, CLEAR_A_COMPANY_DETAIL,
    CLEAR_USER_ACTION_STATUS, CLEAR_A_USER_DETAIL,
    CLEAR_A_DOCTOR_DETAIL, CLEAR_DOCTOR_ACTION_STATUS,
    CLEAR_PATIENT_ACTION_STATUS, CLEAR_LIST_PATIENT, CLEAR_A_PATIENT_DETAIL, CLEAR_PATIENT_LIST_REMOTE_CSV, CLEAR_PATIENT_LIST_REMOTE_EXCEL,
    CLEAR_SYSTEM_SETTING_ACTION_STATUS, CLEAR_A_SYSTEM_SETTING_DETAIL,
    CLEAR_DEPARTMENT_ACTION_STATUS, CLEAR_A_DEPARTMENT_DETAIL,
    CLEAR_SCHEDULE_MEDICAL_ACTION_STATUS, CLEAR_A_SCHEDULE_MEDICAL_DETAIL,
    CLEAR_PATIENT_RESULT_ACTION_STATUS, CLEAR_A_PATIENT_RESULT_DETAIL, CLEAR_MEDICINE_TO_PDF,
    CLEAR_SERVICE_PRICE_ACTION_STATUS, CLEAR_A_SERVICE_PRICE_DETAIL, CLEAR_SERVICE_PRICE_LIST_REMOTE_CSV, CLEAR_SERVICE_PRICE_LIST_REMOTE_EXCEL,
    CLEAR_MEDICINE_ACTION_STATUS, CLEAR_A_MEDICINE_DETAIL, CLEAR_MEDICINE_LIST_REMOTE_CSV, CLEAR_MEDICINE_LIST_REMOTE_EXCEL,
    CLEAR_ENTERPRISE_ACTION_STATUS, CLEAR_A_ENTERPRISE_DETAIL
} from './actionTypes';

export const fetchDataRequest = (type) => ({
    type
});

export const fetchDataSuccess = (type, item) => ({
    type,
    payload: item
});

export const fetchDataError = (type, error) => ({
    type,
    payload: { error }
});

export const clearGlobalErrorMsg = (payload) => ({
    type: CLEAR_GLOBAL_ERROR_MSG,
    payload
});

export const nextStepAction = (step) => ({
    type: NEXT_STEP,
    payload: {
        step
    }
});

export const setNavTab = (payload) => ({
    type: SET_NAV_TAB,
    payload
});

export const setSidebarMobileOpen = (payload) => ({
    type: SET_SIDEBAR_MOBILE_OPEN,
    payload
});

// System Setting
export const clearASystemSettingDetail = () => ({
    type: CLEAR_A_SYSTEM_SETTING_DETAIL,
    payload: null
});

export const clearSystemSettingActionStatus = () => ({
    type: CLEAR_SYSTEM_SETTING_ACTION_STATUS,
    payload: null
});

// User
export const clearUserActionStatus = () => ({
    type: CLEAR_USER_ACTION_STATUS,
    payload: null
});

export const clearAUserDetail = () => ({
    type: CLEAR_A_USER_DETAIL,
    payload: null
});

// Company
export const setCompanyLogoFile = (payload) => ({
    type: SET_COMPANY_LOGO_FILE,
    payload
});

export const deleteCompanyLogoFile = (payload) => ({
    type: DELETE_COMPANY_LOGO_FILE,
    payload
});

export const clearCompanyActionStatus = () => ({
    type: CLEAR_COMPANY_ACTION_STATUS,
    payload: null
});

export const clearACompanyDetail = () => ({
    type: CLEAR_A_COMPANY_DETAIL,
    payload: null
});

// Department
export const clearDepartmentActionStatus = () => ({
    type: CLEAR_DEPARTMENT_ACTION_STATUS,
    payload: null
});

export const clearADepartmentDetail = () => ({
    type: CLEAR_A_DEPARTMENT_DETAIL,
    payload: null
});

// Patient
export const clearPatientActionStatus = () => ({
    type: CLEAR_PATIENT_ACTION_STATUS,
    payload: null
});

export const clearListPatient = () => ({
    type: CLEAR_LIST_PATIENT,
    payload: null
});

export const clearAPatientDetail = () => ({
    type: CLEAR_A_PATIENT_DETAIL,
    payload: null
});

export const clearPatientListRemoteCSV = () => ({
    type: CLEAR_PATIENT_LIST_REMOTE_CSV,
    payload: null
});

export const clearPatientListRemoteExcel = () => ({
    type: CLEAR_PATIENT_LIST_REMOTE_EXCEL,
    payload: null
});

// Doctor
export const clearDoctorActionStatus = () => ({
    type: CLEAR_DOCTOR_ACTION_STATUS,
    payload: null
});

export const clearADoctorDetail = () => ({
    type: CLEAR_A_DOCTOR_DETAIL,
    payload: null
});

// Patient Result
export const clearPatientResultActionStatus = () => ({
    type: CLEAR_PATIENT_RESULT_ACTION_STATUS,
    payload: null
});

export const clearMedicineToPDF = () => ({
    type: CLEAR_MEDICINE_TO_PDF,
    payload: null
});

export const clearAPatientResultDetail = () => ({
    type: CLEAR_A_PATIENT_RESULT_DETAIL,
    payload: null
});

// Service Price
export const clearServicePriceActionStatus = () => ({
    type: CLEAR_SERVICE_PRICE_ACTION_STATUS,
    payload: null
});

export const clearAServicePriceDetail = () => ({
    type: CLEAR_A_SERVICE_PRICE_DETAIL,
    payload: null
});

export const clearServicePriceListRemoteCSV = () => ({
    type: CLEAR_SERVICE_PRICE_LIST_REMOTE_CSV,
    payload: null
});

export const clearServicePriceListRemoteExcel = () => ({
    type: CLEAR_SERVICE_PRICE_LIST_REMOTE_EXCEL,
    payload: null
});

// Medicine
export const clearMedicineActionStatus = () => ({
    type: CLEAR_MEDICINE_ACTION_STATUS,
    payload: null
});

export const clearAMedicineDetail = () => ({
    type: CLEAR_A_MEDICINE_DETAIL,
    payload: null
});

export const clearMedicineListRemoteCSV = () => ({
    type: CLEAR_MEDICINE_LIST_REMOTE_CSV,
    payload: null
});

export const clearMedicineListRemoteExcel = () => ({
    type: CLEAR_MEDICINE_LIST_REMOTE_EXCEL,
    payload: null
});

// Schedule Medical
export const clearScheduleMedicalActionStatus = () => ({
    type: CLEAR_SCHEDULE_MEDICAL_ACTION_STATUS,
    payload: null
});

export const clearAScheduleMedicalDetail = () => ({
    type: CLEAR_A_SCHEDULE_MEDICAL_DETAIL,
    payload: null
});

// Enterprise
export const clearEnterpriseActionStatus = () => ({
    type: CLEAR_ENTERPRISE_ACTION_STATUS,
    payload: null
});

export const clearAEnterpriseDetail = () => ({
    type: CLEAR_A_ENTERPRISE_DETAIL,
    payload: null
});